import React, { ReactElement } from 'react';
import Checkbox from '../checkbox/checkbox.component';
import useStylesListItemCheckbox from './list-item-checkbox.styles';

const ListItemCheckbox: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_LIST_ITEM_CHECKBOX: string = 'list-item-checkbox';

  const {
    isChecked,
    itemId,
    onClick,
  } = props;

  const { classes } = useStylesListItemCheckbox();

  const inputId: string | undefined = itemId ? `${ID_PREFIX_LIST_ITEM_CHECKBOX}-${itemId}` : undefined;

  return (
    <Checkbox
      isChecked={isChecked}
      id={inputId}
      className={classes.listItemCheckbox}
      onClick={onClick}
    />
  );
});

export default ListItemCheckbox;
